import SocketIrsfa from '../SocketIrsfa';

export const replyMessage = (number, message, dataFile) => {
    SocketIrsfa.emit('reply.message', {phone: number, message: message, dataFile: dataFile ? dataFile : null});
};